module.exports = __webpack_public_path__ + "img/share-variant-outline-blk.98230fae.svg";